import { FaqSchema } from "@/components/FaqSchema";
import { ContentPageNav } from "@/components/ContentPageNav";
import { Footer } from "@/components/Footer";

const html = `<nav aria-label="Kruimelpad" class="px-3 pt-4 pb-2"><div class="container mx-auto max-w-6xl"><ol class="flex flex-wrap items-center gap-2 text-sm"><li class="flex items-center gap-2"><a href="/" class="text-muted-foreground hover:text-foreground transition-colors">Home</a></li><li class="text-foreground font-medium" aria-current="page">Tossochtend organiseren</li></ol></div></nav>

  <header class="py-10 md:py-20 px-3">
    <div class="container mx-auto max-w-3xl">
      <h1 class="text-3xl md:text-5xl font-bold text-foreground mb-6">Tossochtend organiseren op je tennisclub</h1>
      <p class="text-lg md:text-xl text-muted-foreground leading-relaxed">De <strong>tossochtend</strong> is voor veel tennisclubs een vast moment in de week. Senioren, thuiswerkers en early-birds komen samen voor wisselende partners en een ontspannen partijtje dubbelspel. Met De Hussel App regel je het zonder dat een tossleider de hele ochtend aan de bar zit.</p>
    </div>
  </header>

  <article class="px-3 pb-6">
    <div class="container mx-auto max-w-3xl space-y-8">
      
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Wat maakt een tossochtend bijzonder?</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ul class="list-disc pl-6 space-y-1"><li>Vaste, trouwe groep — meestal hetzelfde groepje per week.</li><li>Banen zijn rustiger overdag.</li><li>Sociaal, met koffie en koek tussendoor.</li><li>Vaak een mix van niveaus, gewoon voor de gezelligheid.</li></ul></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Tossochtend automatiseren in 4 stappen</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ol class="list-decimal pl-6 space-y-1"><li>Reserveer banen in jullie eigen baanreserveringssysteem.</li><li>Maak in De Hussel App een toss-sessie aan met starttijd en aantal rondes.</li><li>Leden melden zich aan via hun mobiel — vooraf of last-minute.</li><li>De app maakt elke ronde een nieuwe indeling en stuurt push-meldingen met baan en partners.</li></ol></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Tip: koppel een terugkerende sessie</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>De meeste clubs draaien dezelfde tossochtend wekelijks. In De Hussel App stel je een terugkerend schema in, zodat leden iedere week direct kunnen aanmelden zonder dat een beheerder een nieuwe sessie hoeft te maken.</p></div>
        </section>
    </div>
  </article>

  <section class="py-10 md:py-16 px-3">
    <div class="container mx-auto max-w-3xl">
      <div class="p-5 md:p-10 text-center rounded-lg border border-accent/30 bg-accent/10">
        <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Klaar om dit voor je club te automatiseren?</h2>
        <p class="text-lg text-muted-foreground mb-6">De Hussel App regelt aanmelden, indelen en push-meldingen — voor husselen, tossen en racket trekken.</p>
        <a href="/club-register" class="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent text-accent-foreground font-medium hover:bg-accent/90 transition-colors">Registreer je club </a>
      </div>
    </div>
  </section>

  
  <section class="py-10 md:py-16 px-3">
    <div class="container mx-auto max-w-4xl">
      <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-6 md:mb-8 text-center">Veelgestelde vragen</h2>
      <div class="space-y-3">
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Wat is het verschil tussen een tossochtend en een tossavond?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Inhoudelijk niets — alleen het tijdstip. De tossochtend trekt vooral senioren en thuiswerkers, de tossavond werkende leden.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Is een tossochtend ook geschikt voor padel?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Ja. De Hussel App ondersteunt tennis én padel. Per baan stel je in om welke sport het gaat.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Hoeveel deelnemers heb je minimaal nodig?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Minimaal 4 (één baan dubbelspel). In de praktijk werkt het leuker vanaf 8-12 spelers.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Kan ik ook een gemixt seniorentoss organiseren?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Ja. Het algoritme kan op niveau mixen — handig als je een gemengde groep hebt op ochtenden.</div>
    </details></div>
    </div>
  </section>`;

const TossochtendOrganiseren = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <ContentPageNav showPricing />
      <div
        className="flex-1 marketing-content"
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <FaqSchema html={html} />
      <Footer />
    </div>
  );
};

export default TossochtendOrganiseren;
